import { NgIf } from '@angular/common';
import { Component, OnDestroy, OnInit, TemplateRef, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import {
  NbButtonModule,
  NbCardModule,
  NbDialogRef,
  NbDialogService,
  NbIconModule,
  NbInputModule,
  NbToastrService,
  NbTooltipModule
} from '@nebular/theme';
import { Store } from '@ngxs/store';
import { Observable, Subject, takeUntil } from 'rxjs';
import { ImageValidation } from 'src/app/core/services/image-validation.service';
import { RouterState } from 'src/app/features/auth/redux/router-state';
import { SourceImage } from 'src/app/models/drb-models/source-image';
import { ACTIONS, BUNDLE_NAMES, PREFIX } from 'src/app/shared/constants/general-constants';
import { NgxGenericModalComponent } from 'src/app/shared/ui/ngx-generic-modal/ngx-generic-modal.component';
import { DrbState, SaveSourceImagesState } from '../../../redux';
import { DrbService } from '../../../services/drb.service';

@Component({
  selector: 'app-edit-image',
  templateUrl: './edit-image.component.html',
  styleUrls: ['./edit-image.component.css', '../../../../../shared/common_syles.css'],
  imports: [NbCardModule, NgIf, NbIconModule, NbButtonModule, NbTooltipModule, FormsModule, NbInputModule]
})
export class EditImageComponent implements OnInit, OnDestroy {
  public username$: Observable<string> = inject(Store).select(RouterState.username);
  private unsubscribe: Subject<void> = new Subject();
  private childRef: NbDialogRef<unknown>;

  public action;
  public image: SourceImage;
  public sourceImageState: {};
  public username = '';
  public ids;
  public patternId = '^[a-zA-Z0-9_]+$';
  public patternLocation = '^[^\'"]*$';
  public bundle_name: string;

  constructor(
    protected ref: NbDialogRef<EditImageComponent>,
    private store: Store,
    private dialogService: NbDialogService,
    private toastrService: NbToastrService,
    private ImageValidation: ImageValidation,
    private drbService: DrbService,
    private router: Router
  ) {}

  public ngOnInit() {
    this.bundle_name = this.router.url.split('/')[2];
    let drb = this.store.selectSnapshot(DrbState.getByKey(this.bundle_name));
    this.sourceImageState = drb.source.images;
    const allDrbIds = this.drbService.getDrbIds();
    this.ids = allDrbIds.string
      .concat(allDrbIds.file)
      .concat(allDrbIds.image)
      .concat(allDrbIds.link)
      .concat(allDrbIds.video);
    this.username$.pipe(takeUntil(this.unsubscribe)).subscribe((data) => (this.username = data));
  }

  public ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  public async save() {
    const localSourceImage = JSON.parse(JSON.stringify(this.sourceImageState));

    if (this.action === ACTIONS.CREATE) {
      const imageId = this.prefix() + this.image.id + '_dmc';
      if (this.ids.includes(imageId)) {
        this.toastrService.show('', $localize`${imageId} already exists!`, { status: 'danger' });
      } else {
        if (await this.ImageValidation.validateImage(this.image.location)) {
          this.image.id = imageId;
          this.image.created_by = this.username;
          this.image.created_ts = Math.floor(Date.now() / 1000);
          this.image.last_updated_by = this.username;
          this.image.last_updated_ts = Math.floor(Date.now() / 1000);
          this.image.file = this.ImageValidation.fileName;

          localSourceImage.push(this.image);
          this.store.dispatch(new SaveSourceImagesState(localSourceImage, this.bundle_name));
          this.ref.close();
        }
      }
    } else if (this.action === ACTIONS.EDIT) {
      if (await this.ImageValidation.validateImage(this.image.location)) {
        const index = localSourceImage.findIndex((item) => item.id === this.image.id);
        localSourceImage[index].location = this.image.location;
        localSourceImage[index].file = this.ImageValidation.fileName;
        localSourceImage[index].last_updated_by = this.username;
        localSourceImage[index].last_updated_ts = Math.floor(Date.now() / 1000);

        this.store.dispatch(new SaveSourceImagesState(localSourceImage, this.bundle_name));
        this.ref.close();
      }
    }
  }
  public close() {
    this.dialogService
      .open(NgxGenericModalComponent, {
        context: {
          title: $localize`Confirm Close`,
          message: $localize`Are you sure that you want to close the window? Any changes that you have made will be lost.`
        }
      })
      .onClose.subscribe((data) => {
        if (data) {
          this.ref.close();
        }
      });
  }

  public closeInfo() {
    this.childRef.close();
  }

  public drbImageInfo(template: TemplateRef<any>) {
    this.childRef = this.dialogService.open(template, {
      closeOnEsc: true,
      closeOnBackdropClick: true
    });
  }

  public prefix() {
    if (this.bundle_name === BUNDLE_NAMES.MARKETING) {
      return PREFIX.MKT;
    } else if (this.bundle_name === BUNDLE_NAMES.MARKETING_TRANSLATIONS) {
      return PREFIX.MKT_T;
    }
  }
}
